/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty, remove } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getEvidenceFilesList } from "../../../apis/evidence-files";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { dateToViewFormat, getDay } from "../../../utils/date";
import { onLoadMultiImage } from "../../../utils/image";
import { getParams } from "../../../utils/params";
import { permissionCheck } from "../../../utils/permission";
import { taskDetail, taskRequest } from "../../../utils/task";
import { isImage } from "../../../utils/validator/image";

import { TASK_STATUS_LIST } from "../../../constants/TASK";
import DataComponent from "../../../components/DataComponent";

const EVIDENCE_TYPE = [
  {
    label: "매입 거래명세",
    value: "purchase_invoice",
  },
  {
    label: "매출 거래명세",
    value: "sales_invoice",
  },
  { label: "지출증빙", value: "expense" },
];

const EVIDENCE_FILTER_TYPE = [
  {
    label: "매입 거래명세",
    value: "purchaseInvoice",
  },
  {
    label: "매출 거래명세",
    value: "salesInvoice",
  },
  { label: "지출증빙", value: "expense" },
];

const UploadList = () => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [fields] = useState([
    {
      title: "작성일시",
      key: "createdTime",
      onValue: (value) => {
        return (
          <div className="list-date-wrap">
            <p className="list-date">{dateToViewFormat(value)}</p>
            <p className="list-date-time">{dateToViewFormat(value, "HH:mm")}</p>
          </div>
        );
      },
    },
    { title: "제목", key: "title" },
    { title: "작성자", key: "employeeIdx", type: "profile" },
    { title: "타입명", key: "type", onTranslator: { list: EVIDENCE_TYPE } },
    {
      title: "첨부",
      key: "uploadFiles",
      onValue: (value) => {
        return value.map((v, idx) => (
          <div
            key={idx}
            className="bill-img-wrap"
            //onClick={() => handleOnClick(v)}
            onClick={() => handleOnClick(value, idx)}
          >
            {isImage(v.originalName) ? <img src={v.fileUrl} alt={v.originalName} /> : ''}

          </div>
        ));
      },
    },
    {
      title: "결재상태",
      key: "apprStatus",
      onValue: (value) => {
        //console.log('value: ', value)
        const target = TASK_STATUS_LIST.find(
          (vacation) => vacation.status === value
        );
        //console.log('target: ', target)
        return (
          <DataComponent
            field={{
              type: "badge",
              color: target.color,
              label: target.label,
            }}
          />
        );
      },
    },
  ]);
  const [checkedList, setCheckList] = useState([]);
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      const permission = permissions.find(p => p.code === 'UPLOAD_HISTORY')
      setTargetPermission(permission)
      if (isEmpty(permission))
      {
        permissionCheck(history, "UPLOAD_HISTORY")
      }
    }
  }, [permissions])

  const handleOnClick = (files, selected) => {

    onLoadMultiImage(files, selected)
  };

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      search: {
        title: ""
      },
      range: {
        createdTime: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10
    }
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, [checkedList]);

  const submit = (params) => {
    setIsLoading(true);
    let checked = {};
    if (!isEmpty(checkedList))
    {
      checked = Object.assign(...checkedList.map((v) => ({ [v]: true })));
    }
    getEvidenceFilesList({
      ...getParams(params),
      ...checked,
    })
      .then((response) => {
        setTotal(response.data.totalCount);
        setList(response.data.evidenceFiles);
      })
      .catch(() => { })
      .finally(() => setIsLoading(false));
  };

  const filters = [
    { title: "작성일시", key: "range.createdTime", type: "customdatepicker" },
    {
      title: "선택한 항목만 보기",
      key: "check",
      type: "checkboxes",
      className: "margin-right-16",
      checked: checkedList.includes(),
      checkedList,
      onChange: (checked, value, e) => {
        let _selectedCheckboxes = [];
        if (checked)
        {
          _selectedCheckboxes = [...checkedList, value];
        } else
        {
          _selectedCheckboxes = remove(checkedList, (v) => v !== value);
        }
        setCheckList(_selectedCheckboxes);
      },
      options: {
        list: EVIDENCE_FILTER_TYPE,
      },
    },
    {
      title: "제목",
      key: "search.title",
    },
  ]

  const headerButtons = [
    {
      label: "등록하기",
      action: () => {
        taskRequest('evidence_file_request', {})
      },
    },
  ];

  const openTaskDetail = (data, e) => {
    taskDetail({
      type: "evidence_file_request",
      targetWorkIdx: data.idx,
    })
  }

  return (
    !isEmpty(targetPermission) && (
      <div className="expense-list">
        <PageHeader title={"업로드 내역"} buttons={targetPermission.level > 1 ? headerButtons : []} />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isLoading={isLoading}
          fields={fields}
          list={list}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          total={total}
          submit={handleSubmit}
          onSelect={openTaskDetail}
        />
      </div>
    ));
};

export default UploadList;
